import React from 'react';

const Spinner = (spinnerStyle) => {
  return <div className="spinner"></ div>;
}

export default Spinner;
